export interface EstimativaNegociacao {
  CZACCDNGC 	: string;
  CZACFAZEND	: string;
  CZACDSCFAZ	: string;
  CZACCLTORA	: string;
  CZACCOMPRI	: string;
  CZACDIAOPR	: string;
  CZACCLDDE 	: string;
  CZACCLDATE	: string;
  NZACPRCPE 	: number;
  NZACCUSCLT	: number;
  NZACVLRFRT	: number;
  NZACPRCPLA	: number;
  NZACPISCOF	: number;
  NZACICMS  	: number;
  DZACDTINI 	: Date | undefined;
  DZACDTFIM 	: Date | undefined;
  NZACPRCFOB	: number;
  CZACPROJET	: string;
  CZACINTERV	: string;
  NZACMANEST	: number;
  NZACOPERAD	: number;

  CZACINTERVDESC: string;
}

export interface EstimativaNegociacaoLista {
  items: Array<EstimativaNegociacao>;
  hasNext: boolean;
}


export const defaultEstimativaNegociacao = (): EstimativaNegociacao => {
  return {
    CZACCDNGC 	: '',
    CZACFAZEND	: '',
    CZACDSCFAZ	: '',
    CZACCLTORA	: '',
    CZACCOMPRI	: '1',
    CZACDIAOPR	: '1',
    CZACCLDDE 	: '',
    CZACCLDATE	: '',
    NZACPRCPE 	: 0,
    NZACCUSCLT	: 0,
    NZACVLRFRT	: 0,
    NZACPRCPLA	: 0,
    NZACPISCOF	: 0,
    NZACICMS  	: 0,
    DZACDTINI 	: new Date(),
    DZACDTFIM 	: undefined,
    NZACPRCFOB	: 0,
    CZACPROJET	: '',
    CZACINTERV	: '',
    NZACMANEST	: 0,
    NZACOPERAD	: 0,

    CZACINTERVDESC: '',
  };
};


